import React, { useMemo } from "react";
import _ from "lodash";
import {
  IDSInvestigation,
  ICallSameDaysDataset,
} from "../models/dsException";
import { AS_INVESTIGATION_WIZARD_STEPS } from "../constants";

interface ASDay4TemplateProps {
  investigationValues?: IDSInvestigation;
  osdNumber: number;
  currentDay?: string;
  callSameDaysChunk?: ICallSameDaysDataset[];
  pageIndex?: number;
}

const containerStyle: React.CSSProperties = {
  width: "100vw",
  background: "#f5f7fb",
  padding: "10px 10px 15px",
  lineHeight: "40px",
  fontSize: "18px",
  fontWeight: "bold",
  marginBottom: "15px",
  textTransform: "uppercase",
};

const badgeStyle: React.CSSProperties = {
  background: "#f5f5f5",
  border: "1px solid #d4d4d4",
  padding: "5px 15px",
  borderRadius: "20px",
  fontSize: "14px",
  fontWeight: "bold",
};

const wrapperStyle: React.CSSProperties = {
  width: "calc(100vw - 40px)",
  margin: "0 20px 20px",
  display: "inline-block",
};

const labelStyle: React.CSSProperties = {
  marginBottom: "10px",
};

const infoBoxStyle: React.CSSProperties = {
  width: "75%",
  display: "inline-block",
  background: "#f5f7fb",
  padding: "10px",
  border: "1px solid #b5b6b9",
  wordWrap: "break-word",
  marginBottom: "10px",
};

const InfoBlock: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <>
    <div style={labelStyle}>{label}</div>
    <div style={infoBoxStyle}>{value}</div>
  </>
);

const ASDay4Template: React.FC<ASDay4TemplateProps> = ({
  investigationValues,
  osdNumber,
  currentDay,
  callSameDaysChunk,
  pageIndex = 0,
}): JSX.Element | null => {
  const values = useMemo(() => investigationValues, [investigationValues]);

  if (!values || currentDay !== AS_INVESTIGATION_WIZARD_STEPS[3]) return null;

  return (
    <div id="as-in-day4">
      <div style={{ width: "100%", fontFamily: "calibri" }}>
        <div style={containerStyle}>
          All Shortage Investigation Day 4{" "}
          <span style={badgeStyle}>#{osdNumber}</span>
        </div>
      </div>

      {callSameDaysChunk && (
        <div style={wrapperStyle}>
          <div style={labelStyle}>Call same day deliveries and pickups</div>

          <div>
            <div style={{ width: "15vw", display: "inline-block", verticalAlign: "top" }}>
              {values.callSameDays === "Y" ? "Yes" : "No"}
            </div>

            {values.callSameDays === "Y" &&
              callSameDaysChunk.map((c, index) => {
                const datasetIndex = index + pageIndex;
                return (
                  <React.Fragment key={c.sameDayPro}>
                    <div style={labelStyle}>
                      <h3 className="header-text mb-0">
                        <strong>Pro and Delivery Info: {datasetIndex + 1}</strong>
                      </h3>
                    </div>

                    <InfoBlock
                      label="Pro Number:"
                      value={_.get(values, `callSameDaysDataset[${datasetIndex}].sameDayPro`, "—")}
                    />

                    <InfoBlock
                      label="Delivery Info?:"
                      value={_.get(values, `callSameDaysDataset[${datasetIndex}].deliveryInfo`, "—")}
                    />
                  </React.Fragment>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(ASDay4Template);
